import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { styled } from '@linaria/react'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Portal } from 'react-portal'

import closeModal from '../../utils/closeModal'
import Icon from '../icon'

const Container = styled.div`
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  background-color: var(--primary);
  border-radius: 8px;
  border: 1px solid var(--highlight-txt-gold);
  padding: 18px 24px;
  width: calc(100% - 24px);
  z-index: 20;
  opacity: 0;
  bottom: 0px;
  pointer-events: none;
  transition: all 0.2s ease-in-out;
  gap: 12px;
  @keyframes popup {
    0% {
      bottom: 0px;
      opacity: 0;
    }
    100% {
      bottom: 85px;
      opacity: 1;
    }
  }
  .theme-dark & {
    box-shadow: 0 0 10px rgba(255, 255, 255, 0.3);
  }
  .theme-light & {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  }
  &.active {
    bottom: 85px;
    opacity: 1;
    pointer-events: auto;
    animation: popup 0.2s ease-in-out;
  }
`

const Close = styled.button`
  display: flex;
  position: absolute;
  top: 0;
  right: 0;
  padding: 12px;
  cursor: pointer;
  * {
    pointer-events: none;
  }
  svg {
    fill: var(--txt);
  }
`

const IosDownloadBanner = () => {
  const modal = useModal()
  const { t } = useTranslation('common')

  useEffect(() => {
    if (location.pathname !== '/') closeModal(modal)
  }, [location.pathname])

  return (
    <Portal>
      <Container className={`${modal.visible && 'active'} dark:bg-primary-bg`}>
        <Close id="pwa-icon-close" onClick={() => closeModal(modal)}>
          <Icon id="close" width="10" height="10" />
        </Close>

        <div>
          {/* Title */}
          <h3 className="text-highlight-txt-gold text-xl font-bold text-center">
            Descarga la app
          </h3>

          {/* Subtitle */}
          <p className="text-txt text-base text-center mt-1">
            para retiro instantáneo{' '}
            <span className="text-highlight-txt-gold font-semibold">
              más rápido y seguro
            </span>
          </p>

          {/* Features */}
          <div className="flex items-center justify-center gap-6 mt-4">
            <div className="flex items-center gap-1.5">
              <span className="text-base">🚀</span>
              <span className="text-txt text-base">
                Más rápido{' '}
                <span className="text-highlight-txt-gold">en la app</span>
              </span>
            </div>
            <div className="flex items-center gap-1.5">
              <span className="text-base">✅</span>
              <span className="text-highlight-txt-gold text-base">
                Más seguro
              </span>
            </div>
          </div>
          <button
            onClick={() =>
              window.open(
                'https://apps.apple.com/mx/app/mexplay/id6469581767?l=en-GB',
                '_blank',
              )
            }
            className="w-full mt-5 text-center py-3 rounded-lg text-base font-bold uppercase text-white tracking-wider border-solid border-2 border-[#c8a249]"
            style={{
              background:
                'linear-gradient(180deg, #4caf50 0%, #2e7d32 50%, #1b5e20 100%)',
              boxShadow:
                '0 0 12px rgba(200,162,73,0.5), 0 0 24px rgba(200,162,73,0.2), inset 0 1px 0 rgba(255,255,255,0.2)',
            }}>
            {t('download-app')}
          </button>
        </div>
      </Container>
    </Portal>
  )
}

export default NiceModal.create(IosDownloadBanner)
